import React from 'react';
import './Accueil.css';
import SectionAccueil from "../components/SectionAccueil/SectionAccueil";
import SectionProchainMatch from "../components/SectionProchainMatch/SectionProchainMatch";
import SectionHistoire from "../components/SectionHistoire/SectionHistoire";
import SectionResultats from "../components/SectionResultats/SectionResultats";
import SectionSponsors from "../components/SectionSponsors/SectionSponsors";
import Classement from "../components/Classement/Classement";

function Accueil() {
    return (
        <div className="accueil">
            <main>
                <SectionAccueil />
                <SectionHistoire />
                <SectionProchainMatch />
                <SectionResultats />
                <div>
                <Classement competitionId={"441214"} limitedWidth={true} />
                </div>
                    <SectionSponsors />
            </main>
        </div>
    );
}

export default Accueil;
